import _ from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import StaticItem from './StaticItem';
import { getMenuItemListStyles } from '../styles/main-menu-styles';

class StaticItemList extends React.PureComponent {
  render() {
    const {
      classes,
      items,
      isExpanded,
      onMenuItemClick,
      classList,
      permissions,
    } = this.props;
    const isNavRefresh = isNavigationRefreshOn(permissions);
    const cnames = classNames(['main-menu-link-list',
      classes.menuList,
      isNavRefresh ? null : classes.menuListBorder,
      ...classList]);

    return (
      <div className={cnames}>{
        isExpanded &&
        <div >
          {items.map(item =>
          (
            <StaticItem
              key={item.Id}
              node={item}
              renderText={isExpanded ? item.Name : null}
              onItemClick={onMenuItemClick}
            />
          ))}
        </div>
      }
      </div>
    );
  }
}

StaticItemList.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemListStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  classList: PropTypes.arrayOf(PropTypes.string),
  isExpanded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.string,
    Name: PropTypes.string.isRequired,
  })),
  onMenuItemClick: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

StaticItemList.defaultProps = {
  items: [],
  classList: [],
};

export const StyledStaticItemList = withPermissions(withDefaultStyles(StaticItemList, getMenuItemListStyles));
